import { render, staticRenderFns } from "./ContactFilePreview.vue?vue&type=template&id=0978d6bb&scoped=true&"
import script from "./ContactFilePreview.vue?vue&type=script&lang=js&"
export * from "./ContactFilePreview.vue?vue&type=script&lang=js&"
import style0 from "./ContactFilePreview.vue?vue&type=style&index=0&id=0978d6bb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0978d6bb",
  null
  
)

export default component.exports